import React from "react";
import PropTypes from "prop-types";
import style from "./style.module.scss";

/**
 * Wrapper
 *  - Wrapper for MenuContentList in TAB view
 */
export function Wrapper(props) {
  const className = `${style.wrapper} ${props.className}`;
  return <div className={className}>{props.children}</div>;
}

Wrapper.propTypes = {
  /**
   * ClassName
   */
  className: PropTypes.string,
  /**
   * Array of components to display on MenuContentList
   */
  children: PropTypes.oneOfType([
    PropTypes.array,
    PropTypes.string,
    PropTypes.element,
  ]),
};

Wrapper.defaultProps = {
  className: "",
};
